import {TripbookRepository} from "../../../repositories/TripbookRepository.ts";

export class WarmTripbookUseCase{
    constructor(private tripbooksRepository: TripbookRepository){}
    async execute(): Promise<void>{
        return this.tripbooksRepository.warmTripbook();
    }
}
